import { path } from './internal/path';
export const convert = path('/convert');
